export const iconFontAwesomeEducationMasksTheater = (
	<i className="fa-solid fa-masks-theater"></i>
);
